import { GlobalSettings, TournamentSettings } from '@repo/database/src/types';

export enum SettingType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
}

export const isSettingType = (value: unknown): value is SettingType => {
  return Object.values(SettingType).includes(value as SettingType);
};

export enum SettingCategory {
  TOURNAMENT = 'tournament',
}

export type GlobalSettingsDto = GlobalSettings;
export type TournamentSettingDto = TournamentSettings;

export interface CreateGlobalSettingDto {
  key: string;
  value: string;
  type: SettingType;
  category: string;
  description: string;
}

export interface UpdateGlobalSettingDto {
  value?: string;
  type?: SettingType;
  category?: string;
  description?: string;
}

// explicit coupling to DB records for now
export interface GlobalSettingsOptions {
  pauseTitle: string;
  pauseDescription: string;
}

// explicit coupling to DB records for now
export interface TournamentSettingsOptions {
  pauseTitle: string;
  pauseDescription: string;
}
